<table *ngIf="specifications?.length > 1; else single">
  <caption class="section-heading">
    Size and construction
  </caption>
  <tbody>
    <ng-container *ngFor="let sizeAndConName of sizeAndConNames">
      <tr
        [ngClass]="{
          'r-table--4': specifications?.length === 3,
          'r-table--6': specifications?.length === 2,
          hidden: !getIsDifferences(sizeAndConName) && hideSpecDifferenceRows
        }"
        class="r-table__row"
        *ngIf="getSpecByName(specifications[0], sizeAndConName)"
      >
        <th class="r-table__heading text--left" scope="row">
          {{ getSpecByName(specifications[0], sizeAndConName)?.name }}
        </th>

        <ng-container *ngFor="let item of specifications">
          <td
            [ngClass]="{
              'r-table__cell--highlight': getSpecByName(item, sizeAndConName)
                ?.highlight
            }"
            class="r-table__cell"
          >
            <span
              class="{{
                hasWhiteSpace(getSpecByName(item, sizeAndConName)?.value)
                  ? 'break-word'
                  : 'break-all'
              }}"
            >
              {{ getSpecByName(item, sizeAndConName)?.value }}
            </span>
          </td>
        </ng-container>
      </tr>
    </ng-container>
    <tr class="r-table__row">
      <td
        class="r-table__heading"
        [attr.colspan]="(specifications?.length || 0) + 1"
        aria-hidden="true"
      ></td>
    </tr>
    <tr class="r-table__row">
      <th
        class="r-table__cell section-heading"
        [attr.colspan]="(specifications?.length || 0) + 1"
        scope="colgroup"
      >
        Other specifications
      </th>
    </tr>
    <tr
      [ngClass]="{
        'r-table--4': specifications?.length === 3,
        'r-table--6': specifications?.length === 2,
        hidden: !getIsDifferences(spec) && hideSpecDifferenceRows
      }"
      class="r-table__row"
      *ngFor="
        let spec of getSpecsWithoutSizeAndConNames(specifications[0]);
        index as i
      "
    >
      <th class="r-table__heading text--left" scope="row">
        {{ spec }}
      </th>

      <ng-container *ngFor="let item of specifications">
        <td
          [ngClass]="{
            'r-table__cell--highlight': getSpecByName(item, spec)?.highlight
          }"
          class="r-table__cell"
        >
          <span
            class="{{
              hasWhiteSpace(getSpecByName(item, spec)?.value)
                ? 'break-word'
                : 'break-all'
            }}"
          >
            {{ getSpecByName(item, spec)?.value }}
          </span>
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>
<ng-template #single>
  <table class="single-column">
    <caption class="sr-only">
      Specifications
    </caption>
    <tbody>
      <tr
        [class.hidden]="visibleRows && i >= visibleRows"
        class="r-table__row"
        *ngFor="let spec of specifications[0]; index as i"
      >
        <ng-container *ngFor="let item of specifications">
          <td>
            <small
              ><strong>{{ specifications[0][i]?.name }}</strong></small
            >
          </td>
          <td class="r-table__cell">
            <p>
              <small>
                {{ item[i]?.value }}
              </small>
            </p>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</ng-template>
